/**
 * When the renewal reminder was last dismissed, per user.
 *
 * Suffixed with the user id because two accounts can share a browser, and one
 * teacher dismissing the prompt must not silence it for the other. The cadence
 * itself (`RENEWAL_REMINDER_INTERVAL_DAYS`) lives in `@app/common` — it is a
 * subscription rule, not a storage detail.
 */
export function renewalReminderStorageKey(userId: string): string {
  return `tutor_renewal_reminder:${userId}`;
}
